export default __webpack_public_path__ + "static/media/homepage-map-pin-icon-smaller.f6fbe4bb.svg";